// components/Forms/AddEvaluationForm.jsx
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { createStatement, updateStatement } from "../../api/evaluationApi";

const AddEvaluationForm = ({
  lessonId,
  grade,
  book,
  setStatementsMap,
  showSuccess,
  showError,
  addStatement, // شیء شامل { id, content, type: 'edit' } یا null
  setAddStatement,
}) => {
  const validationSchema = Yup.object({
    content: Yup.string()
      .required("متن گزاره الزامی است")
      .min(5, "حداقل ۵ کاراکتر وارد کنید")
      .max(500, "حداکثر ۵۰۰ کاراکتر مجاز است"),
  });

  const handleAddStatement = async (formData, resetForm) => {
    try {
      const data = {
        content: formData.content,
        grade: grade,
        lessonId: lessonId,
        book: book,
      };

      const res = await createStatement(data);

      if (res.status === 201) {
        const lessonId = data.lessonId;
        setStatementsMap((prev) => ({
          ...prev,
          [lessonId]: [res.data.statement, ...(prev[lessonId] || [])],
        }));
        showSuccess("گزاره با موفقیت اضافه شد");
        return true;
      } else {
        showError(res.message || "خطا در افزودن گزاره");
        return false;
      }
    } catch (err) {
      showError("خطا در ارتباط با سرور");
      return false;
    }
  };

  const handleUpdateStatement = async (formData, resetForm) => {
    try {
      const data = {
        content: formData.content,
        id: addStatement.id,
      };

      const res = await updateStatement(data);
      if (res.status === 200) {
        const lessonId = res.data.statement.lessonId;
        setStatementsMap((prev) => {
          const updatedList = (prev[lessonId] || []).map((s) =>
            s._id === addStatement.id ? res.data.statement : s,
          );
          return { ...prev, [lessonId]: updatedList };
        });

        showSuccess("گزاره با موفقیت ویرایش شد");
        return true;
      } else {
        showError(res.message || "خطا در ویرایش گزاره");
        return false;
      }
    } catch (err) {
      showError("خطا در ارتباط با سرور");
      return false;
    }
  };

  // تعیین onSubmit بر اساس وجود addStatement
  const onSubmit = (values, { resetForm, setSubmitting }) => {
    const handler =
      addStatement?.type === "edit"
        ? handleUpdateStatement
        : handleAddStatement;
    handler(values, resetForm).finally(() => setSubmitting(false));
  };

  return (
    <Formik
      initialValues={{ content: addStatement?.content || "" }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize={true} // کلید اصلی برای به‌روزرسانی مقدار فیلد
    >
      {({ errors, touched, isSubmitting, submitForm }) => (
        <Form className="bg-gray-50 rounded-lg p-4 space-y-3 border border-gray-200">
          <h4 className="text-sm font-medium text-gray-700">
            {addStatement?.type === "edit"
              ? "ویرایش گزاره"
              : "افزودن گزاره جدید"}
          </h4>

          <div>
            <Field
              as="textarea"
              name="content"
              rows="3"
              placeholder="متن گزاره ارزشیابی را وارد کنید..."
              className={`w-full px-3 py-2 text-sm rounded-lg border ${
                errors.content && touched.content
                  ? "border-red-500 focus:ring-red-500"
                  : "border-gray-300 focus:ring-blue-500"
              } focus:ring-2 focus:border-transparent outline-none transition`}
            />
            {errors.content && touched.content && (
              <div className="text-red-500 text-xs mt-1">{errors.content}</div>
            )}
          </div>

          <div className="flex justify-end">
            <button
              type="button"
              onClick={submitForm}
              disabled={isSubmitting}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
            >
              {isSubmitting ? "در حال تایید..." : "تایید"}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddEvaluationForm;
